export default "__VITE_ASSET__ujH6UQ$0__"